import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../components/Header';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);

        // Home page locks body scroll for Locomotive Scroll; restore native scrolling here
        document.body.style.overflow = 'auto';
        document.body.style.overflowX = 'hidden';
        document.documentElement.style.overflow = 'auto';

        if (window.locoScroll) {
            window.locoScroll.destroy();
            window.locoScroll = null;
        }

        return () => {
            document.body.style.overflow = '';
            document.body.style.overflowX = '';
            document.documentElement.style.overflow = '';
        };
    }, []);

    return (
        <>
            <Header />
            <div className="privacy-policy-page">
                <div className="privacy-policy-hero">
                    <div className="container">
                        <h1>Privacy Policy</h1>
                        <p className="effective-date">Effective Date: July 16, 2026</p>
                    </div>
                </div>

                <div className="privacy-policy-content">
                    <div className="container">
                        <p className="intro">
                            SaihaTask respects your privacy and is committed to protecting your personal information.
                        </p>

                        <section>
                            <h2>Information We Collect</h2>
                            <p>
                                SaihaTask may collect information such as your name, email address, phone number,
                                profile information, and task or project data necessary to provide our services.
                                We may also collect basic device and diagnostic information to improve app
                                performance and security.
                            </p>
                        </section>

                        <section>
                            <h2>How We Use Your Information</h2>
                            <p>We use your information to:</p>
                            <ul>
                                <li>Provide and maintain the SaihaTask service.</li>
                                <li>Manage your account and projects.</li>
                                <li>Send notifications related to tasks and updates.</li>
                                <li>Improve the performance, reliability, and security of the app.</li>
                            </ul>
                        </section>

                        <section>
                            <h2>Data Sharing</h2>
                            <p>
                                We do not sell your personal information. Information may be shared only with
                                trusted service providers or when required by law.
                            </p>
                        </section>

                        <section>
                            <h2>Data Security</h2>
                            <p>
                                We take reasonable measures to protect your information from unauthorized access,
                                disclosure, or misuse.
                            </p>
                        </section>

                        <section>
                            <h2>Contact Us</h2>
                            <p>If you have any questions about this Privacy Policy, please contact us:</p>
                            <p>
                                <strong>Website:</strong>{' '}
                                <a href="https://saihatask.com/" target="_blank" rel="noopener noreferrer">
                                    https://saihatask.com/
                                </a>
                            </p>
                            <p>
                                <strong>Email:</strong>{' '}
                                <a href="mailto:business@saihasoft.com">business@saihasoft.com</a>
                            </p>
                        </section>
                    </div>
                </div>
            </div>

            <footer className="footer-block">
                <div className="footer-main">
                    <div className="container-fluid">
                        <div className="footer-section align-items-center" id="footer-navigation">
                            <div className="logo-footer">
                                <img
                                    src="assets/images/rays-footer-logo.png"
                                    className="footer-logo mb-4"
                                    alt="Saihatask"
                                />
                                <p>
                                    Saihatask empowers teams to <br /> plan, track, and complete work <br />{' '}
                                    efficiently through simple, smart <br /> task management since 2022.
                                </p>
                            </div>
                            <div className="about-rays-footer">
                                <Link to="/#About-saiha">About Us</Link>
                                <Link to="/#program-id">Features</Link>
                                <Link to="/#blog-id">Blog</Link>
                            </div>
                            <div className="education-footer">
                                <Link to="/#program-id">Task Boards</Link>
                                <Link to="/#program-id">Project Tracker</Link>
                                <Link to="/#program-id">Daily Review</Link>
                                <Link to="/#program-id">Role-Based Access</Link>
                            </div>
                            <div className="volunteer-footer">
                                <Link to="/#contact-id">Help Center</Link>
                                <Link to="/#contact-id">Request A Demo</Link>
                                <Link to="/#contact-id">Become A Partner</Link>
                                <Link to="/#contact-id">Contact Us</Link>
                                <Link to="/privacy-policy">Privacy Policy</Link>
                            </div>
                            <div className="social-icons-footer">
                                <a
                                    href="https://www.facebook.com/profile.php?id=61576934409284"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src="assets/images/facebook.png" alt="Facebook" className="social-icon" />
                                </a>
                                <a
                                    href="https://www.instagram.com/Saihatask/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src="assets/images/insta.png" alt="Instagram" className="social-icon" />
                                </a>
                                <a
                                    href="https://www.youtube.com/@saihatask"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    <img src="assets/images/youtube.png" alt="Youtube" className="social-icon" />
                                </a>
                                <a href="https://x.com/saihatask" target="_blank" rel="noopener noreferrer">
                                    <img src="assets/images/twit.png" alt="Twitter" className="social-icon" />
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyrights text-white">
                    <div className="copyrights_div d-flex justify-content-between">
                        <div>
                            <p className="saihasoft-link">© 2026 Saihatask. All Rights Reserved.</p>
                        </div>
                        <div>
                            <a
                                href="http://saihasoft.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="saihasoft-link"
                            >
                                Created by Saihasoftware technologies Pvt Ltd.
                            </a>
                        </div>
                    </div>
                </div>
            </footer>
        </>
    );
};

export default PrivacyPolicy;
